import { useEffect } from "react";
import { FormHelperText } from "@mui/material";
import DatePicker from "@components/DatePicker/DatePicker";
import CustomFormLabel from "@components/FormItem/FormItem.styles";
import { usePortServicesFlow } from "@features/vessel-call/vessel-call-status/PortServices/flow/context/PortServicesFlowContext";

const asDateOrNull = (v: unknown) => (v == null || v === "" ? null : (v as Date));

interface ETSFieldProps {
  serviceDetails: { ets?: Date | null | string };
}

const ETSField = ({ serviceDetails: { ets: currentEts } }: ETSFieldProps) => {
  const { setEts, ets, errors } = usePortServicesFlow();

  useEffect(() => {
    if (currentEts instanceof Date) {
      setEts(currentEts);
    } else if (typeof currentEts === "string" && currentEts !== "") {
      setEts(new Date(currentEts));
    } else {
      setEts(null);
    }
  }, [currentEts, setEts]);

  if (!currentEts) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <CustomFormLabel data-testid={`change-status-ETS-label`}>ETS</CustomFormLabel>
      <DatePicker
        hasError={errors.ets !== undefined}
        value={asDateOrNull(ets)}
        onChange={() => {}}
        disabled={true}
        testId="change-status-ETS-datepicker"
        timePicker={true}
        combinedInput={true}
        dateConstraint="not-past"
      />
      {errors.ets && (
        <FormHelperText sx={{ color: "error.main", m: 0 }}>
          {typeof errors.ets === "string" ? errors.ets : errors.ets?.toString()}
        </FormHelperText>
      )}
    </div>
  );
};

export default ETSField;
